export default "__VITE_ASSET__d15b5955__"